import script from './ChartingChecklistItemCard.vue2.js';
import normalizeComponent from '../../../../node_modules/vue-runtime-helpers/dist/normalize-component.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.item
    ? _c(
        "div",
        [
          _c(
            "Checkbox",
            {
              class: { "js-highlight": _vm.item.highlight },
              attrs: { value: _vm.item.checked, highlight: _vm.item.highlight },
              on: { input: _vm.setCheckedValue }
            },
            [_vm._v("\n    " + _vm._s(_vm.item.label) + "\n  ")]
          ),
          _vm._v(" "),
          _vm.item.highlight
            ? _c("label", { staticClass: "error is-block pb-5" }, [
                _vm._v("\n    Please check this required checkbox\n  ")
              ])
            : _vm._e()
        ],
        1
      )
    : _c("div", [_c("b-skeleton", { attrs: { width: "100px" } })], 1)
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export { __vue_component__ as default };
